"use client";

"use client";

import React from 'react';

/**
 * @description Shared pill badge — used for "NEW" labels across HCP and DTC.
 * Renders appearance only; positioning (absolute/relative) is the consumer's
 * responsibility via the `className` prop.
 *
 * @param {ReactNode} children   — badge text
 * @param {string}    className  — additional class for positioning overrides
 * @param {string}    ariaLabel  — accessible label (defaults to children text)
 */
function Badge({ children, className, ariaLabel }) {
  const cls = `badge${className ? ` ${className}` : ''}`;
  return (
    <span className={cls} aria-label={ariaLabel}>
      {children}
    </span>
  );
}

export default Badge;
